export const activeSubstance = {
    state: {
        status: 'idle',
        activeSubstance: null
    },
    mutations: {
        SET_ACTIVESUBSTANCE_STATUS(state, status) {
            state.status = status
        },
        SET_ACTIVESUBSTANCE(state, activeSubstance) {
            state.activeSubstance = activeSubstance
        }
    },
    actions: {
        fetchActiveSubstance({ state, commit }, payload) {
            commit('SET_ACTIVESUBSTANCE', null)
            commit('SET_ACTIVESUBSTANCE_STATUS', 'loading')
            return this.$api.get(`api/active-substances/${payload}.json`).then(response => {
                commit('SET_ACTIVESUBSTANCE', response.data.data)
                commit('SET_ACTIVESUBSTANCE_STATUS', 'idle')
            }).catch(error => {
                commit('SET_ACTIVESUBSTANCE_STATUS', 'error')
                return Promise.reject(error)
            })
        }
    },
    getters: {
        activeSubstanceStatus: (state) => {
            return state.status
        },
        activeSubstance: (state) => {
            if(state.activeSubstance) {
                return state.activeSubstance
            }
        }
    }
}
